import { useFormikContext } from "formik";
import * as Immutable from "immutable";
import { flushSync } from "react-dom";
export const createFilterActions = ({
  submitForm,
  setFieldValue,
  values: { searchFilters: selectedFilters = Immutable.OrderedMap() }
}) => {
  const updateFilters = (searchFilters, shouldSubmitForm = true) => {
    setFieldValue("searchFilters", searchFilters);
    if (shouldSubmitForm) {
      flushSync(() => submitForm());
    }
  };
  const updateFilter = (frontendId, searchFilter) => {
    const curFilter = selectedFilters.get(frontendId);
    updateFilters(
      selectedFilters.set(frontendId, searchFilter instanceof Function ? searchFilter(curFilter) : searchFilter)
    );
  };
  const addFilter = (searchFilter, shouldSubmitForm) => {
    updateFilters(selectedFilters.set(searchFilter.frontendId, searchFilter), shouldSubmitForm);
  };
  return { updateFilters, updateFilter, addFilter };
};
const useSearchFiltersFormActions = () => {
  const formikContext = useFormikContext();
  return createFilterActions(formikContext);
};
export default useSearchFiltersFormActions;
